import { useQuery } from "react-query";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

/**
 * Fetches the canonical application schema from the API.
 * Cached aggressively (staleTime: Infinity) since the schema rarely changes.
 *
 * @returns {{ schema: Object|undefined, isLoading: boolean, error: Error|null }}
 */
export const useApplicationSchema = () => {
  const auth = useAuth();

  const { data, isLoading, error } = useQuery(
    ["applicationSchema"],
    async () => {
      const response = await makeApiRequest(
        "get",
        apiRoutes.getApplicationSchema,
        auth.user,
        auth.user.companyId
      );
      return response.data;
    },
    {
      enabled: !!auth.user,
      staleTime: Infinity,
      cacheTime: 1000 * 60 * 60, // 1 hour
    }
  );

  return { schema: data, isLoading, error };
};
